export interface Faq {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: 'Is Fitness Senior Ready™ a physical product?',
    a: 'No. It is a 100% digital system available immediately after purchase. Use it from your computer, tablet or smartphone.',
  },
  {
    q: 'Who is this designed for?',
    a: 'Senior fitness coaches, personal trainers, group fitness instructors, active-aging professionals and other qualified fitness professionals who work with older adults.',
  },
  {
    q: 'Is the system mostly theory?',
    a: 'No. Fitness Senior Ready™ has been designed around visual, practical resources including exercises, activities, complete classes, circuits, progressions and programming tools. The goal is to make the material easier to understand, select and use in real coaching situations.',
  },
  {
    q: 'Are the classes ready to use?',
    a: 'Yes. The system includes complete class structures and ready-to-teach sessions you can select and adapt according to your participants, environment and professional judgment.',
  },
  {
    q: 'Does it include gym-based training?',
    a: 'Yes. The system includes strength and functional training activities using equipment such as dumbbells, resistance bands, steps, chairs and other senior-friendly training tools.',
  },
  {
    q: 'Is everything chair-based?',
    a: 'No. Chair-based options are included where useful, but the complete system covers a much broader range of senior fitness training, including standing strength, functional movement, balance, coordination, mobility, gym-based activities, circuits and active-aging sessions.',
  },
  {
    q: 'Can I use it with different ability levels?',
    a: 'Yes. Progressions, regressions and adaptation options help you adjust activities according to participant capabilities and your professional judgment.',
  },
  {
    q: 'Do I get lifetime access?',
    a: 'Yes. Your purchase includes lifetime access to the digital resources included with your order.',
  },
  {
    q: 'Are the bonuses included?',
    a: 'Yes. All five premium bonuses are included with the current offer at no additional cost.',
  },
]
